export var Group;
(function (Group) {
    Group["KNOW"] = "KNOW";
    Group["EXPLORE"] = "EXPLORE";
    Group["PLAN"] = "PLAN";
    Group["INTEGRATE"] = "INTEGRATE";
})(Group || (Group = {}));
export var Status;
(function (Status) {
    Status["IN_PROGRESS"] = "IN_PROGRESS";
    Status["FOR_REVIEW"] = "FOR_REVIEW";
    Status["COMPLETE"] = "COMPLETE";
})(Status || (Status = {}));
export var Priority;
(function (Priority) {
    Priority["HIGH"] = "HIGH";
    Priority["MEDIUM"] = "MEDIUM";
    Priority["LOW"] = "LOW";
})(Priority || (Priority = {}));
export var Choice;
(function (Choice) {
    Choice["UNSET"] = "UNSET";
    Choice["YES"] = "YES";
    Choice["NO"] = "NO";
})(Choice || (Choice = {}));
